import nhlAnaheimDucks from './nhl/anaheim-ducks.svg';
import nhlBostonBruins from './nhl/boston-bruins.svg';
import nhlBuffaloSabres from './nhl/buffalo-sabres.svg';
import nhlCalgaryFlames from './nhl/calgary-flames.svg';
import nhlCarolinaHurricanes from './nhl/carolina-hurricanes.svg';
import nhlChicagoBlackhawks from './nhl/chicago-blackhawks.svg';
import nhlColoradoAvalanche from './nhl/colorado-avalanche.svg';
import nhlColumbusBlueJackets from './nhl/columbus-blue-jackets.svg';
import nhlDallasStars from './nhl/dallas-stars.svg';
import nhlDetroitRedWings from './nhl/detroit-red-wings.svg';
import nhlEdmontonOilers from './nhl/edmonton-oilers.svg';
import nhlFloridaPanthers from './nhl/florida-panthers.svg';
import nhlLosAngelesKings from './nhl/los-angeles-kings.svg';
import nhlMinnesotaWild from './nhl/minnesota-wild.svg';
import nhlMontrealCanadiens from './nhl/montreal-canadiens.svg';
import nhlNashvillePredators from './nhl/nashville-predators.svg';
import nhlNewJerseyDevils from './nhl/new-jersey-devils.svg';
import nhlNewYorkIslanders from './nhl/new-york-islanders.svg';
import nhlNewYorkRangers from './nhl/new-york-rangers.svg';
import nhlOttawaSenators from './nhl/ottawa-senators.svg';
import nhlPhiladelphiaFlyers from './nhl/philadelphia-flyers.svg';
import nhlPittsburghPenguins from './nhl/pittsburgh-penguins.svg';
import nhlSanJoseSharks from './nhl/san-jose-sharks.svg';
import nhlSeattleKraken from './nhl/seattle-kraken.svg';
import nhlStLouisBlues from './nhl/st-louis-blues.svg';
import nhlTampaBayLightning from './nhl/tampa-bay-lightning.svg';
import nhlTorontoMapleLeafs from './nhl/toronto-maple-leafs.svg';
import nhlUtahMammoth from './nhl/utah-mammoth.svg';
import nhlVancouverCanucks from './nhl/vancouver-canucks.svg';
import nhlVegasGoldenKnights from './nhl/vegas-golden-knights.svg';
import nhlWashingtonCapitals from './nhl/washington-capitals.svg';
import nhlWinnipegJets from './nhl/winnipeg-jets.svg';
import shlBrynasIf from './shl/brynas-if.svg';
import shlDjurgardensIf from './shl/djurgardens-if.svg';
import shlFrolundaHc from './shl/frolunda-hc.svg';
import shlFarjestadBk from './shl/farjestad-bk.svg';
import shlHv71 from './shl/hv71.svg';
import shlLeksandsIf from './shl/leksands-if.svg';
import shlLinkopingHc from './shl/linkoping-hc.svg';
import shlLuleaHockey from './shl/lulea-hockey.svg';
import shlMalmoRedhawks from './shl/malmo-redhawks.svg';
import shlRogleBk from './shl/rogle-bk.svg';
import shlSkellefteaAik from './shl/skelleftea-aik.svg';
import shlTimraIk from './shl/timra-ik.svg';
import shlVaxjoLakers from './shl/vaxjo-lakers.svg';
import shlOrebroHockey from './shl/orebro-hockey.svg';
import shlBjorkloven from './shl/bjorkloven.svg';
import khlAvtomobilistYekaterinburg from './khl/avtomobilist-yekaterinburg.svg';
import khlCskaMoscow from './khl/cska-moscow.svg';
import khlDynamoMoscow from './khl/dynamo-moscow.svg';
import khlLokomotivYaroslavl from './khl/lokomotiv-yaroslavl.svg';
import khlNeftekhimikNizhnekamsk from './khl/neftekhimik-nizhnekamsk.svg';
import khlSibirNovosibirsk from './khl/sibir-novosibirsk.svg';
import khlSkaSaintPetersburg from './khl/ska-saint-petersburg.svg';
import khlSpartakMoscow from './khl/spartak-moscow.svg';
import nlEhcBielBienne from './nl/ehc-biel-bienne.webp';
import nlEhcKloten from './nl/ehc-kloten.webp';
import nlEvZug from './nl/ev-zug.webp';
import nlFribourgGotteron from './nl/fribourg-gotteron.webp';
import nlGeneveServetteHc from './nl/geneve-servette-hc.webp';
import nlHcAjoie from './nl/hc-ajoie.webp';
import nlHcAmbriPiotta from './nl/hc-ambri-piotta.webp';
import nlHcDavos from './nl/hc-davos.webp';
import nlHcLugano from './nl/hc-lugano.webp';
import nlLausanneHc from './nl/lausanne-hc.webp';
import nlScBern from './nl/sc-bern.webp';
import nlSclTigers from './nl/scl-tigers.webp';
import nlScrjLakers from './nl/scrj-lakers.webp';
import nlZscLions from './nl/zsc-lions.webp';
import { FOOTBALL_LOGOS } from './football';

export interface TeamLogo {
  src: string;
  abbr?: string;
}

export const TEAM_LOGOS: Record<string, Record<string, TeamLogo>> = {
  NHL: {
    'Anaheim Ducks': { src: nhlAnaheimDucks, abbr: 'ANA' },
    'Boston Bruins': { src: nhlBostonBruins, abbr: 'BOS' },
    'Buffalo Sabres': { src: nhlBuffaloSabres, abbr: 'BUF' },
    'Calgary Flames': { src: nhlCalgaryFlames, abbr: 'CGY' },
    'Carolina Hurricanes': { src: nhlCarolinaHurricanes, abbr: 'CAR' },
    'Chicago Blackhawks': { src: nhlChicagoBlackhawks, abbr: 'CHI' },
    'Colorado Avalanche': { src: nhlColoradoAvalanche, abbr: 'COL' },
    'Columbus Blue Jackets': { src: nhlColumbusBlueJackets, abbr: 'CBJ' },
    'Dallas Stars': { src: nhlDallasStars, abbr: 'DAL' },
    'Detroit Red Wings': { src: nhlDetroitRedWings, abbr: 'DET' },
    'Edmonton Oilers': { src: nhlEdmontonOilers, abbr: 'EDM' },
    'Florida Panthers': { src: nhlFloridaPanthers, abbr: 'FLA' },
    'Los Angeles Kings': { src: nhlLosAngelesKings, abbr: 'LAK' },
    'Minnesota Wild': { src: nhlMinnesotaWild, abbr: 'MIN' },
    'Montréal Canadiens': { src: nhlMontrealCanadiens, abbr: 'MTL' },
    'Nashville Predators': { src: nhlNashvillePredators, abbr: 'NSH' },
    'New Jersey Devils': { src: nhlNewJerseyDevils, abbr: 'NJD' },
    'New York Islanders': { src: nhlNewYorkIslanders, abbr: 'NYI' },
    'New York Rangers': { src: nhlNewYorkRangers, abbr: 'NYR' },
    'Ottawa Senators': { src: nhlOttawaSenators, abbr: 'OTT' },
    'Philadelphia Flyers': { src: nhlPhiladelphiaFlyers, abbr: 'PHI' },
    'Pittsburgh Penguins': { src: nhlPittsburghPenguins, abbr: 'PIT' },
    'San Jose Sharks': { src: nhlSanJoseSharks, abbr: 'SJS' },
    'Seattle Kraken': { src: nhlSeattleKraken, abbr: 'SEA' },
    'St. Louis Blues': { src: nhlStLouisBlues, abbr: 'STL' },
    'Tampa Bay Lightning': { src: nhlTampaBayLightning, abbr: 'TBL' },
    'Toronto Maple Leafs': { src: nhlTorontoMapleLeafs, abbr: 'TOR' },
    'Utah Mammoth': { src: nhlUtahMammoth, abbr: 'UTA' },
    'Vancouver Canucks': { src: nhlVancouverCanucks, abbr: 'VAN' },
    'Vegas Golden Knights': { src: nhlVegasGoldenKnights, abbr: 'VGK' },
    'Washington Capitals': { src: nhlWashingtonCapitals, abbr: 'WSH' },
    'Winnipeg Jets': { src: nhlWinnipegJets, abbr: 'WPG' },
  },
  SHL: {
    'Björklöven': { src: shlBjorkloven, abbr: 'IFB' },
    'Brynäs IF': { src: shlBrynasIf, abbr: 'BIF' },
    'Djurgårdens IF': { src: shlDjurgardensIf, abbr: 'DIF' },
    'Frölunda HC': { src: shlFrolundaHc, abbr: 'FHC' },
    'Färjestad BK': { src: shlFarjestadBk, abbr: 'FBK' },
    'HV71': { src: shlHv71, abbr: 'HV71' },
    'Leksands IF': { src: shlLeksandsIf, abbr: 'LIF' },
    'Linköping HC': { src: shlLinkopingHc, abbr: 'LHC' },
    'Luleå Hockey': { src: shlLuleaHockey, abbr: 'LHF' },
    'Malmö Redhawks': { src: shlMalmoRedhawks, abbr: 'MIF' },
    'Rögle BK': { src: shlRogleBk, abbr: 'RBK' },
    'Skellefteå AIK': { src: shlSkellefteaAik, abbr: 'SKE' },
    'Timrå IK': { src: shlTimraIk, abbr: 'TIK' },
    'Växjö Lakers': { src: shlVaxjoLakers, abbr: 'VLH' },
    'Örebro Hockey': { src: shlOrebroHockey, abbr: 'ÖRE' },
  },
  KHL: {
    'Avtomobilist Yekaterinburg': { src: khlAvtomobilistYekaterinburg },
    'CSKA Moscow': { src: khlCskaMoscow },
    'Dynamo Moscow': { src: khlDynamoMoscow },
    'Lokomotiv Yaroslavl': { src: khlLokomotivYaroslavl },
    'Neftekhimik Nizhnekamsk': { src: khlNeftekhimikNizhnekamsk },
    'Sibir Novosibirsk': { src: khlSibirNovosibirsk },
    'SKA Saint Petersburg': { src: khlSkaSaintPetersburg },
    'Spartak Moscow': { src: khlSpartakMoscow },
  },
  NL: {
    'EHC Biel-Bienne': { src: nlEhcBielBienne, abbr: 'EHCB' },
    'EHC Kloten': { src: nlEhcKloten, abbr: 'EHCK' },
    'EV Zug': { src: nlEvZug, abbr: 'EVZ' },
    'Fribourg-Gottéron': { src: nlFribourgGotteron, abbr: 'FRI' },
    'Genève-Servette HC': { src: nlGeneveServetteHc, abbr: 'GSHC' },
    'HC Ajoie': { src: nlHcAjoie, abbr: 'HCA' },
    'HC Ambri-Piotta': { src: nlHcAmbriPiotta, abbr: 'HCAP' },
    'HC Davos': { src: nlHcDavos, abbr: 'HCD' },
    'HC Lugano': { src: nlHcLugano, abbr: 'HCL' },
    'Lausanne HC': { src: nlLausanneHc, abbr: 'LHC' },
    'SC Bern': { src: nlScBern, abbr: 'SCB' },
    'SC Rapperswil-Jona Lakers': { src: nlScrjLakers, abbr: 'SCRJ' },
    'SCL Tigers': { src: nlSclTigers, abbr: 'SCL' },
    'SCRJ Lakers': { src: nlScrjLakers, abbr: 'SCRJ' },
    'ZSC Lions': { src: nlZscLions, abbr: 'ZSC' },
  },
};

Object.entries(FOOTBALL_LOGOS).forEach(([league, teams]) => {
  TEAM_LOGOS[league] = Object.fromEntries(
    Object.entries(teams).map(([team, path]) => [
      team,
      { src: `${process.env.PUBLIC_URL}/logos/football/${path}.webp` },
    ])
  );
});
